export default "__VITE_ASSET__BM89EGTT__"